const stickyScroll = new (class {
  constructor() {
    const items = [...document.querySelectorAll(".sticky-scroll__section > *")];
    console.log(items);
    items.forEach((item) => {
      IntersectionHandler.addListener(item,
        () => item.classList.add("sticky-scroll--visible"),
        () => item.classList.remove("sticky-scroll--visible")
      );
    });
  }
})();